/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgNeo4JAiNeutralBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={5.5} cy={5.5} r={1.5} stroke="currentColor" strokeWidth={1.5} />
    <circle
      cx={18.5}
      cy={18.5}
      r={1.5}
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="M12.7885 15.6345L12 18L11.2115 15.6345C10.7636 14.2908 9.70919 13.2364 8.36546 12.7885L6 12L8.36546 11.2115C9.70919 10.7636 10.7636 9.70919 11.2115 8.36546L12 6L12.7885 8.36546C13.2364 9.70919 14.2908 10.7636 15.6345 11.2115L18 12L15.6345 12.7885C14.2908 13.2364 13.2364 14.2908 12.7885 15.6345Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M15 21.418C15 21.418 9.56707 23.7462 4.91039 19.0895C0.253721 14.4328 2.58211 9 2.58211 9"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M9 2.58204C9 2.58204 14.4329 0.253777 19.0896 4.9105C23.7463 9.56722 21.4179 15 21.4179 15"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
const SvgNeo4JAiNeutral = wrapIcon(SvgNeo4JAiNeutralBase);
export default SvgNeo4JAiNeutral;
